import React, { useState } from 'react';
import Recaptcha from 'react-google-recaptcha';
import styled from 'styled-components';
import { useForm } from '@formcarry/react';
import { useSize } from '../utils';
import { theme, media, color, breakpoints } from '../theme';
import { FormSuccess } from './FormSuccess';

const RECAPTCHA_KEY = process.env.SITE_RECAPTCHA_KEY;

const regex = {
  name: /^[a-zA-Z\s]+$/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const ContactForm = () => {
  // Call the `useForm` hook in your function component
  const { state, submit } = useForm({
    id: 'jZsZirNnRbT1',
  });

  const [ loadCaptcha, setLoadCaptcha ] = useState(false);
  // const [ showCaptcha, setShowCaptcha ] = useState(false);

  const [ itemStatus, setItemStatus ] = useState({});
  // const [ showVerify, setShowVerify ] = useState(false);

  // Set to false when using captcha
  // const [ allowSubmitting, setAllowSubmitting ] = useState(true);

  function handleSubmit(e) {
    // if (allowSubmitting) {
    submit();
    // } else {
    // e.preventDefault();
    // setShowVerify(true);
    // }
  }

  function handleChange({ target }) {
    const { value, name } = target;

    const invalid = (value.match(regex[name]) === null);

    if (!invalid || typeof itemStatus[name] !== 'undefined') {
      setItemStatus({ ...itemStatus, [name]: invalid });
    }
  }

  function handleBlur({ target }) {
    const { value, name } = target;

    const isInvalid = (value.match(regex[name]) === null);

    if (value.length > 0) setItemStatus({ ...itemStatus, [name]: isInvalid });
  }

  // Success message
  if (state.submitted) {
    return <FormSuccess>Din besked blev sendt.</FormSuccess>;
  }

  function beginLoadCaptcha() {
    if (!loadCaptcha) setLoadCaptcha(true);
  }

  function handleInputFocus() {
    beginLoadCaptcha();
  }

  function handleTextareaFocus() {
    beginLoadCaptcha();
    // setShowCaptcha(true);
  }

  return (
    <Form
      name="contact-recaptcha"
      method="post"
      onSubmit={handleSubmit}
    >
      <noscript>
        <p>This form won’t work with Javascript disabled</p>
      </noscript>

      <Row>
        <label aria-label="Navn" htmlFor="footer-name" aria-invalid={itemStatus.name}>
          <input
            type="text"
            id="footer-name"
            name="name"
            onChange={handleChange}
            onFocus={handleInputFocus}
            onBlur={handleBlur}
            placeholder="Navn"
            required
            aria-invalid={itemStatus.name}
          />
        </label>
        <label aria-label="Email" htmlFor="footer-email" aria-invalid={itemStatus.email}>
          <input
            type="email"
            id="footer-email"
            name="email"
            onChange={handleChange}
            onFocus={handleInputFocus}
            onBlur={handleBlur}
            placeholder="Email"
            required
            aria-invalid={itemStatus.email}
          />
        </label>
      </Row>

      <label aria-label="Besked" htmlFor="your-message">
        <textarea id="your-message" name="message" onChange={handleChange} placeholder="Besked" onFocus={handleTextareaFocus} />
      </label>

      <Row style={{ marginTop: theme.containerPadding }}>
        {/* <div className="recaptcha-wrapper">
          { loadCaptcha && (
            <>
              <Recaptcha
                sitekey={RECAPTCHA_KEY}
                className="recaptcha"
                style={{
                  opacity: showCaptcha ? 1 : 0,
                  transitionDuration: theme.transitionLong,
                  transitionTimingFunction: theme.transitionFunction,
                  transitionDelay: '1s',
                }}
                onChange={(v) => setAllowSubmitting(typeof v === 'string' && v.length > 0)}
              />
              {showVerify && <span style={{ position: 'relative', top: -15 }}>Verificer venligst!</span>}
            </>
          )}
        </div> */}

        <button className="btn yellow-fill" type="submit">Send besked</button>
      </Row>
    </Form>
  );
};

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${theme.containerPadding};
  flex-wrap: wrap;

  label {
    display: block;
    width: calc(50% - ${useSize(theme.containerPadding) / 2}px);
  }

  .recaptcha-wrapper {
    @media ${media.landscapeS} {  
      width: 304px;
      height: 78px;
    }

    @media ${media.landscapeM} {  
      width: auto;
      height: auto;
      /* margin-bottom: 20px; */
    }
  }

  .recaptcha {
    @media (max-width: ${breakpoints.landscapeS - 1}px) {
      > * {
        transform: scale(0.85);
        transform-origin: 0% 0%;
      }
    }

    @media (max-width: 995px) {
      opacity: 1 !important;
      overflow: hidden;
    }

    @media ${media.landscapeM} {  
      margin-bottom: 20px;
    }
  }

  @media ${media.landscapeS} {
    flex-wrap: nowrap;
  }

  @media ${media.landscapeM} {
    flex-wrap: wrap;
  }
`;

const Form = styled.form`
  input, textarea {
    background: ${color.offwhite};
  }
`;
